/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_Closing_TitleInputs */

const en_gc_home_closing_title = /** @type {(inputs: Gc_Home_Closing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your next idea has a place to start.`)
};

const zh_gc_home_closing_title = /** @type {(inputs: Gc_Home_Closing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个想法，有了开始的地方。`)
};

/**
* | output |
* | --- |
* | "Your next idea has a place to start." |
*
* @param {Gc_Home_Closing_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_closing_title = /** @type {((inputs?: Gc_Home_Closing_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Closing_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_closing_title(inputs)
	return zh_gc_home_closing_title(inputs)
});
export { gc_home_closing_title as "gc.home.closing_title" }